// NodeAnnualDateField.jsx

import React from 'react';

// CSS
import './NodeAnnualDateField.css';

// Components
import NodeAnnualDateInput from './NodeAnnualDateInput';
import NodeTemporalReadOnlyValue from 'node/form/fields/utilities/NodeTemporalReadOnlyValue';

/**
 * NodeAnnualDateField
 *
 * Displays a schema-driven annual-date field with month/day/year controls.
 * In readOnly / previewMode: friendly label (e.g. Dec 31).
 *
 * @param {object|null} value - Current annual-date field value.
 * @param {Function} onChange - Callback when the annual date changes.
 * @param {boolean} [readOnly=false]
 * @param {boolean} [previewMode=false]
 *
 * @returns {ReactNode} The rendered annual-date field.
 */
const NodeAnnualDateField = ({
  value,
  onChange,
  readOnly = false,
  previewMode = false,
}) => {
  const isReadOnly = Boolean(readOnly || previewMode);

  if (isReadOnly) {
    return (
      <div className="node-annual-date-field-container is-readonly">
        <NodeTemporalReadOnlyValue value={value} fieldType="annualdate" />
      </div>
    );
  }

  return (
    <div className="node-annual-date-field-container">
      <NodeAnnualDateInput
        value={value}
        onChange={onChange}
      />
    </div>
  );
};

NodeAnnualDateField.displayName = 'NodeAnnualDateField';

export default NodeAnnualDateField;
